import {
  CircularProgress as MuiCircularProgress,
  type CircularProgressProps as MuiCircularProgressProps,
  LinearProgress as MuiLinearProgress,
  type LinearProgressProps as MuiLinearProgressProps
} from "@mui/material";

export type CircularProgressProps = MuiCircularProgressProps;
export type LinearProgressProps = MuiLinearProgressProps;

export const CircularProgress = MuiCircularProgress;
export const LinearProgress = MuiLinearProgress;
